export default __webpack_public_path__ + "static/media/special_net.5156d8c4.svg";